export enum LocalStorageKeys {
	UnsubscribeEmail = 'checkoutUnsubscribeEmail',
	EmailThatPasswordWasGeneratedFor = 'emailPasswordWasGeneratedFor'
}
